export const RESPONSE_ERRORS = Object.freeze({
  TWO_FA_ENABLED: "Invalid or missing 2FA credentials.",
});

export default {};
